import {
    Button,
    ButtonGroup,
    ClickAwayListener,
    Grow,
    IconButton,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    TableCell,
    Tooltip
} from "@mui/material";
import styles from "./drive-row.module.css";
import * as React from "react";
import {ACTIONS, ALLOWED_IMAGE_EDIT_EXT, ALLOWED_PREV_EXT, ALLOWED_UNCOMPRESS_EXT, options} from "./driveRowConst";
import {Close, MoreVertOutlined} from "@mui/icons-material";
import {UPLOAD_STATUS} from "../../config/appConst";
import useDrive from "../../hooks/useDrive";
import FileService from "../../services/FileService";
import FileFolderDeleteDialog from "../FileFolderDeleteDialog";
import FileUncompressDialog from "../FileUncompressDialog";
import FileCADDialog from "../FileCADDialog";
import {Buffer} from 'buffer';

export default function DriveRowActionCell({show, row, cell, grid, loadMe}) {
    const {
        CurrentDrive,
        changeRenameRow,
        setCopyPath,
        changePreviewObject,
        changeEditorObject,
        changeRenameFolder
    } = useDrive();

    const anchorRef = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const [deleteDialog, setDeleteDialog] = React.useState(false);
    const [unCompressDialog, setUnCompressDialog] = React.useState(false);
    const [cadDialog, setCADDialog] = React.useState(false);

    const handleMenuItemClick = action => {
        switch (action) {
            case ACTIONS.FILE_DOWNLOAD:
                downloadFile(row);
                break;
            case ACTIONS.FILE_RENAME:
                changeRenameRow(row)
                break;
            case ACTIONS.FOLDER_RENAME:
                changeRenameFolder(row);
                break;
            case ACTIONS.FILE_COPY:
            case ACTIONS.FILE_MOVE:
            case ACTIONS.FOLDER_COPY:
            case ACTIONS.FOLDER_MOVE:
                setCopyPath({path: CurrentDrive.parent, type: action, name: row.Key, sourceDrive: CurrentDrive.driveType})
                break;
            case ACTIONS.FILE_DELETE:
            case ACTIONS.FOLDER_DELETE:
                setDeleteDialog(true);
                break;
            case ACTIONS.FILE_PREVIEW:
                changePreviewObject(row);
                break;
            case ACTIONS.IMAGE_EDIT:
                changeEditorObject(row);
                break;
            case ACTIONS.FILE_UNCOMPRESS:
                setUnCompressDialog(true);
                break;
            case ACTIONS.FILE_CAD:
                setCADDialog(row);
                break;
            case ACTIONS.FOLDER_EXPLORE:
                loadMe(row);
                break;    
            default:
                break;
        }
        setOpen(false);
    };

    const downloadFile = async row => {
        const {parent, driveType} = CurrentDrive;
        const url = await FileService.getDownLoadLink(parent, row.Key, driveType);
        download(url.url || url);
    }

    function download(source) {

        // localStorage.setItem('callback', 'smilefyappconnections://')

        if (localStorage.getItem('callback')) {

            let params = [{
                url: source
            }];

            let result = `${localStorage.getItem('callback')}data=${(Buffer.from(JSON.stringify(params))).toString('base64')}`
            // console.log(result);
            window.location.replace(result);

        } else {

            const fileName = source.split('/').pop();
            let el = document.createElement("a");
            el.setAttribute("href", source);
            el.setAttribute("download", fileName);
            el.setAttribute("target", "_blank");
            document.body.append(el);
            el.click();
            el.remove();
        }
    }

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        // console.log(event)
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const loadButton = () => {
        if (show && (row.type === 'folder' || row.type === 'file')) {
            return <ButtonGroup aria-label="split button">
                <IconButton
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="Actions"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                >
                    <MoreVertOutlined fontSize={"small"}/>
                </IconButton>
            </ButtonGroup>
        } else if (row.type === UPLOAD_STATUS.UPLOADING) {
            return <IconButton size={"small"}>
                <Close/>
            </IconButton>
        } else {
            return <Button/>
        }
    }
    const buttonLogic = () => {
        return (<Popper
            style={{zIndex: 10,}}
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
        >
            {({TransitionProps, placement}) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin:
                            placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                >
                    <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList id="split-button-menu" autoFocusItem>
                                {loadActions(true)}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>)
    }
    const loadCell = () => {
        return <TableCell align="right" className={styles.actionCol}>
            {
                loadButton()
            }
            <span ref={anchorRef}/>
            {
                buttonLogic()
            }
        </TableCell>
    }
        const loadGridOptionButton = () => {
        return <dev align="right" className={styles.actionCol}>
            {
                loadButton()
            }
            <span ref={anchorRef}/>

            {
                buttonLogic()
            }
        </dev>
    }

    const getExt = () => {
        const name = row.Key;
        const nameSplit = name.split(".");
        return nameSplit.pop().toLowerCase();
    }
    const loadActions = (menu = false) => {
        if (!row) {

            return '';
        }
        const optionsArr = options[row.type];
        let actions = [];
        for (let i = 0; i < optionsArr.length; i++) {
            const {action, text, icon, permissions} = optionsArr[i];
            const {drivePermission} = CurrentDrive;
            const findPermission = permissions.find(p => drivePermission === p)
            if (!findPermission) {
                continue;
            }
            if (row.type === 'file' && action === ACTIONS.FILE_PREVIEW) {
                const ext = getExt().toLowerCase();
                const previewAllowed = ALLOWED_PREV_EXT.find(x => {
                    return x === ext;
                });
                if (!previewAllowed) {
                    continue;
                }
            } else if (row.type === 'file' && action === ACTIONS.IMAGE_EDIT) {
                const ext = getExt().toLowerCase();
                const imageEditAllowed = ALLOWED_IMAGE_EDIT_EXT.find(x => {
                    return x === ext;
                });
                if (!imageEditAllowed) {
                    continue;
                }
            } else if (row.type === 'file' && action === ACTIONS.FILE_UNCOMPRESS) {
                const ext = getExt().toLowerCase();
                const imageEditAllowed = ALLOWED_UNCOMPRESS_EXT.find(x => {
                    return x === ext;
                });
                if (!imageEditAllowed) {
                    continue;
                }
            }

            if (menu) {
                actions.push(<MenuItem
                    className={styles.optionMenuItem}
                    key={i + action}
                    onClick={() => handleMenuItemClick(action)}
                >
                    {icon} &nbsp;&nbsp; {text}

                </MenuItem>)
            } else {
                actions.push(<Tooltip title={text}>
                    <IconButton
                        size={"small"}
                        key={i + action}
                        onClick={() => handleMenuItemClick(action)}
                        variant={"contained"}
                        // color={"info"}
                        style={{color: "#8c3b61"}}
                    >
                        {icon}
                    </IconButton>
                </Tooltip>);
            }

        }
        return actions;
    }
    return (
        <>
            {cell ? loadCell() : (grid ? loadGridOptionButton() : loadActions())}
            {row ? <FileFolderDeleteDialog row={row} open={deleteDialog} setOpen={setDeleteDialog}/> : ''}
            {row ? <FileUncompressDialog row={row} open={unCompressDialog} setOpen={setUnCompressDialog}/> : ''}
            {row ? <FileCADDialog row={row} open={cadDialog} setOpen={setCADDialog}/> : ''}

        </>

    )

}